<template>
  <div>
    <div class="container">
      <el-row class="item-class-group" v-if="menuIdx.length!==0">
        <el-col class="item-class-name" :span="2">分类:</el-col>
          <el-col class="item-class-select" :span="19">
            <!-- 一级 -->
            <span v-if="menuIdx.length>0&&menuIdx[0]>-1&& exportMenu[menuIdx[0]]" >
              <span class="item-class-spandx">
                {{exportMenu[menuIdx[0]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([])"></i>
              </span>
            </span>
            <!-- 二级 -->
            <span v-if="menuIdx.length>1&&menuIdx[0]>-1&&menuIdx[1]>-1&&exportMenu[menuIdx[0]]&& exportMenu[menuIdx[0]].children&& exportMenu[menuIdx[0]].children[menuIdx[1]]" >
              <i class="el-icon-arrow-right"></i>
              <span class="item-class-spandx">{{exportMenu[menuIdx[0]].children[menuIdx[1]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([menuIdx[0]])"></i>
              </span>
            </span>
            <!-- 三级 -->
            <span v-if="menuIdx.length>2&&menuIdx[0]>-1&&menuIdx[1]>-1&&menuIdx[2]>-1&&exportMenu[menuIdx[0]]&& exportMenu[menuIdx[0]].children&& exportMenu[menuIdx[0]].children[menuIdx[1]]&& exportMenu[menuIdx[0]].children[menuIdx[1]].children[menuIdx[2]]" >
              <i class="el-icon-arrow-right"></i>
              <span class="item-class-spandx">{{exportMenu[menuIdx[0]].children[menuIdx[1]].children[menuIdx[2]].fieldName}}
                <i class="el-icon-close iconstyle" @click="chooseCategory([menuIdx[0],menuIdx[1]])"></i>
              </span>
            </span>
          </el-col>
        <el-col :span="3">
        </el-col>
      </el-row>
      <!-- 一级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===0">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu" :key="index" @click="chooseCategory([index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu.length>5">
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
            <!-- e => show(0, e) -->
          </el-tag>
        </el-col>
      </el-row>
      <!-- 二级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===1&&menuIdx[0]>-1&& exportMenu[menuIdx[0]]&&exportMenu[menuIdx[0]].children">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu[menuIdx[0]].children" :key="index"
            @click="chooseCategory([menuIdx[0],index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu[menuIdx[0]].children.length>5">
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
            <!-- <span @click="e => show(1, e)">{{expandShow?'收起':'展开'}}</span> -->
          </el-tag>
        </el-col>
      </el-row>
      <!-- 三级检索 -->
      <el-row class="item-class-group"  v-if="menuIdx.length===2&&menuIdx[0]>-1&&menuIdx[1]>-1&& exportMenu[menuIdx[0]]&&exportMenu[menuIdx[0]].children&&exportMenu[menuIdx[0]].children[menuIdx[1]]&&exportMenu[menuIdx[0]].children[menuIdx[1]].children">
        <!-- <el-col class="item-class-name" :span="2">&nbsp;</el-col> -->
        <el-col class="item-class-select" :span="21" :style="expandShow?'height: auto;':'height: 26px;'">
          <div v-for="(item, index) in exportMenu[menuIdx[0]].children[menuIdx[1]].children" :key="index"
            @click="chooseCategory([menuIdx[0],menuIdx[1],index])" :title="item.fieldName">
            <span>{{ item.fieldName }}</span>
          </div>
        </el-col>
        <el-col class="actions" :span="3">
          <el-tag type="info" v-show="exportMenu[menuIdx[0]].children[menuIdx[1]].children.length>5">
            <span @click="expandShow=!expandShow">{{expandShow?'收起':'展开'}}</span>
            <!-- <span @click="e => show(1, e)">展开</span> -->
          </el-tag>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <div class="search-box">
        <div class="search-box-input">
          <input
            style="
              width: 870px;
              height: 46px;
              padding-left: 10px;
              border: 1px solid #EEEEEE;
              background: url(data:image/png;base64,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) no-repeat 843.5px 16.2px;
              background-size: 13px 13px;
            "
            placeholder="请输入要查询的内容"
            v-model="inputValue"
            @keypress.enter="search"
          />
        </div>
        <!-- <el-button @click="search()">查询</el-button> -->
        <div @click="search()"
          style="
            width:46px;
            height: 46px;
            margin-left: -46px;
            cursor: pointer
          "
        ></div>
      </div>
      <div class="search-list">
        <el-row v-if="showExportList && showExportList.length">
          <div v-for="item in showExportList" :key="item.id">
            <div class="export">
              <div class="export-opt">
                <img :alt="item.name" @click="routerHandleExportDetail(item)" :src="item.userAvatarUrl || BASE_URL + 'img/zwt.png'" width="130px" height="130px"/>
                <div class="export--opt-but" @click="routerHandleAskExport(item.id, item.name)">我要提问</div>
              </div>
              <div class="export-info">
                <div class="export-info-name overell">
                  {{item.name}} 专家
                </div>
                <div class="export-info-category overell" v-if="item.fileVideoTypeAttributeEntityList&&item.fileVideoTypeAttributeEntityList">
                  <span v-for="it in item.fileVideoTypeAttributeEntityList" :key="it.id">{{it.typeAttributeValue}}</span>
                </div>
                <!-- 专家标签 -->
                <div class="export-info-introduction">
                  <p :title="item.expertIntroduction" style="width: inherit; height: 49px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">{{item.expertIntroduction}}</p>
                </div>
                <div class="export-info-label">
                  <div class="export-about-info" @click="routerHandleExportDetail(item)">
                    <!-- <div class="export-about-info-count">{{item.questionCount||0}}</div> -->
                    <div>{{item.questionCount||0}}&nbsp;&nbsp;个提问</div>
                  </div>
                  <div class="export-about-info" @click="routerHandleExportDetail(item)">
                    <!-- <div class="export-about-info-count">{{item.replyCount||0}}</div> -->
                    <div>{{item.replyCount||0}}&nbsp;&nbsp;个回复</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-row>
        <div style="text-align:center" v-else>
          <img :src="BASE_URL + 'img/kong.png'" alt="暂无数据">
        </div>
      </div>
      <div class="doclist-pagination">
        <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''" v-for="(item, index) in pageList" :key="index" @click="clickPageTo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
        <div class="doclist-jump" @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import { expertDetail, expertPutQuestionsTo } from '@/utils/eventTracking'
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1, // 跳转页
      exportMenu: [], // 专家目录
      menuIdx: [], // 专家索引
      categoryIds: [], // 类目ID
      showExportList: [], // 检索列表
      inputValue: '', // input值
      searchValue: '',
      expandShow: false
    }
  },
  computed: {
    // showExportList () {
    //     if (this.exportList.length && this.currentPage > 0) {
    //         return this.exportList.slice((this.currentPage - 1) * 6, this.currentPage * 6)
    //     } else {
    //         return []
    //     }
    // },
    // totalPage () {
    //     return Math.ceil(this.exportList.length / 6)
    // }
  },
  watch: {
    '$route.query': {
      handler: 'routerWatchFun'
    }
  },
  methods: {
    routerWatchFun () {
      this.getExportsByIdPage()
    },
    routerPush (params = {}) {
      let query = {
        page: 1,
        limit: 10,
        typeId: this.$route.query.typeId || null,
        search: this.$route.query.search || '',
        ...params,
      }
      this.$router.push({
        name: 'chooseExpert',
        query: query
      })
    },
    // show (index, e) {
    //   let oEvevt = e || event
    //   let selects = document.getElementsByClassName('item-class-select')
    //   if (oEvevt.target.innerText === '展开') {
    //       oEvevt.target.innerText = '收起'
    //   } else {
    //       oEvevt.target.innerText = '展开'
    //   }
    //   selects[index].style.height === 'auto' ? selects[index].style.height = '' : selects[index].style.height = 'auto'
    // },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: newCurrent,
        })
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
        this.routerPush({
          page: newCurrent,
        })
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    clickPageTo (newCurrent) {
      this.setExportPage(newCurrent)
      this.routerPush({
        page: newCurrent
      })
    },
    //   第几页
    changePageTo (currentPage) {
      this.setExportPage(currentPage)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 点击检索
    search () {
      this.searchValue = this.inputValue
      this.currentPage = 1
      this.changePageTo(1)
      this.routerPush({
        page: 1,
        search: this.searchValue
      })
    },
    routerHandleAskExport (id, name) {
      if (id) {
        expertPutQuestionsTo(name)
        this.$router.push({
          name: 'askToExpert',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({ name: 'chooseExpert' })
      }
    },
    // 获取所有专家类目
    getCategoryExport () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldtype/findDataByTree`)
        .then(({ data }) => {
          let exportMenu = []
          if (data && data.code === 0) {
            exportMenu = data.data || []
          }
          if (!this.$route.query.searchJson) {
            this.menuIdx = []
            this.exportMenu = exportMenu
          }
        })
    },
    // 获取对应类目下的专家列表
    getExportsByIdPage () {
      let params = {}
      if (this.$route.query.page) {
        params = {
          ...this.$route.query,
          page: Number(this.$route.query.page),
          limit: Number(this.$route.query.limit)
        }
      } else {
        params = {
          page: 1,
          limit: 10,
          search: '',
          typeId: null
        }
      }
      // let searchId = ''
      // if (this.categoryIds.length > 0) {
      //   searchId = this.categoryIds[this.categoryIds.length - 1]
      // }
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/expertField/expertfieldrepliy/findExpertsByTypeId`, params)
        .then(({ data }) => {
          let showExportList = []
          let count = 0
          if (data && data.code === 0) {
            showExportList = data.data.data || []
            count = data.data.count || 0
          }
          this.totalPage = Math.ceil(count / 10)
          this.showExportList = showExportList
          this.setExportPage(params.page)
        })
    },
    setExportPage (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          if (newPageList[newPageList.length - 1] < this.totalPage) {
            this.nextOmit = '...'
          } else {
            this.nextOmit = ''
          }
          if (newPageList[0] > 1) {
            this.lastOmit = '...'
          } else {
            this.lastOmit = ''
          }
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.currentPage = page
        this.lastOmit = ''
        this.nextOmit = ''
      }
    },
    // 获取所有专家及类目
    /* getExpertfield() {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/expertfield/expertfieldrepliy/findAllExpertByFieldType`)
      .then((data) => {
        this.menuIdx = []
        let exportMenu = []
        if (data && data.code === '1' && data.result && data.result.data) {
          exportMenu = data.result.data || []
        }
        let allList = []
        exportMenu.forEach(element => {
            let twoList = []
            if (element.children && element.children.length) {
                element.children.forEach(ele => {
                    let threeList = []
                    if (ele.children && ele.children.length) {
                        ele.children.forEach(item => {
                            if (item.expertFieldRepliyVoList && item.expertFieldRepliyVoList.length) {
                                allList.push(...item.expertFieldRepliyVoList)
                                threeList.push(...item.expertFieldRepliyVoList)
                                twoList.push(...item.expertFieldRepliyVoList)
                            }
                        })
                    }
                    ele.expertFieldRepliyVoList = threeList
                })
            }
            element.expertFieldRepliyVoList = twoList
        });
        this.exportAllList = allList
        this.exportMenu = exportMenu
        this.exportList = allList
        this.changePageTo(1)
      })
    }, */
    //  更改专家类目
    chooseCategory (inds, id) {
      let categoryIds = []
      let expandShow = false
      if (inds.length === 0) {
        // 显示所有专家
        // this.exportList = this.exportAllList
        // categoryIds.push(this.exportMenu[inds[0]].id + '')
        expandShow = this.exportMenu.length > 5
      } else if (inds.length === 1) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        // 一级下所有专家
        // this.exportList = this.exportMenu[inds[0]].expertFieldRepliyVoList
        expandShow = this.exportMenu[inds[0]].children && this.exportMenu[inds[0]].children.length > 5
      } else if (inds.length === 2) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].id + '')
        // 二级下所有专家
        // this.exportList = this.exportMenu[inds[0]].children[inds[1]].expertFieldRepliyVoList
        expandShow = this.exportMenu[inds[0]].children[inds[1]].children && this.exportMenu[inds[0]].children[inds[1]].children.length > 5
      } else if (inds.length === 3) {
        categoryIds.push(this.exportMenu[inds[0]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].id + '')
        categoryIds.push(this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].id + '')
        // 三级下所有专家
        // this.exportList = this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].expertFieldRepliyVoList || []
        expandShow = this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].children && this.exportMenu[inds[0]].children[inds[1]].children[inds[2]].children.length > 5
      }
      this.categoryIds = categoryIds
      this.menuIdx = inds
      this.expandShow = !expandShow
      // this.currentPage = 1
      let searchJson = {
        categoryIds: this.categoryIds,
        menuIdx: this.menuIdx,
        expandShow: this.expandShow,
        exportMenu: this.exportMenu
      }
      this.changePageTo(1)
      this.routerPush({
        page: 1,
        typeId: this.categoryIds[this.categoryIds.length - 1] || '',
        searchJson: JSON.stringify(searchJson)
      })
    },
    // 跳转到专家详细页面
    routerHandleExportDetail (item) {
      expertDetail(item.name)
      this.$router.push({
        name: 'exportDetail',
        query: {
          id: item.id,
          uId: item.userId
        }
      })
    }
  },
  mounted () {
    // this.getExpertfield()
    if (this.$route.query.page) {
      let chooseExpertQuery = this.$route.query
      this.currentPage = chooseExpertQuery.page
      this.searchValue = chooseExpertQuery.search
      if (chooseExpertQuery.searchJson) {
        let chooseExpertSearch = JSON.parse(chooseExpertQuery.searchJson)
        this.categoryIds = chooseExpertSearch.categoryIds
        this.menuIdx = chooseExpertSearch.menuIdx
        this.expandShow = chooseExpertSearch.expandShow
        this.exportMenu = chooseExpertSearch.exportMenu
      }
    }
    this.getCategoryExport()
    this.getExportsByIdPage(1)
  }
}
</script>
<style scoped>
.container{
  width:100%;
  background-color: #ffffff;
  word-wrap: break-word;
  word-break: break-all;
}
.search-box{
    width: 100%;
    padding: 10px 10px;
}
.search-box div{
  display: inline-block;
}
.search-box-input{
  display: inline-block;
  width: 830px;
}
.yjlm{line-height: 40px;
    color: #333;
    border-right: 2px #eee solid;
    padding: 0px 20px;
    height: 40px;
    width: auto;
    display: table;
    float: left;}
.yjlm:hover{background: #1D65A8;color: #ffffff; cursor: pointer;}
.search-list{
  margin: 0 30px;
}
/* 专家信息 */
.export{
  margin-top: 20px;
  /* width: 50%; */
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid #EEEEEE;
}
.export-opt{
  /* width: 136px; */
  height: 176px;
}
.export-opt img{
  width: 130px;
  height: 130px;
  cursor: pointer;
}
.export--opt-but{
  margin: 0 auto;
  margin-top: 12px;
  text-align: center;
  border: 1px solid #1D65A8;
  width: 96px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
}
.export--opt-but:hover{
  background: #1D65A8;
  color: white;
}
.export-info{
  display: block;
  padding-left: 20px;
  width: 100%;
  max-width: 700px;
  position: relative;
  border-bottom: none;
  height: 174px;
}
.export-info-name{
  /* min-width: 100%; */
  /* display: flex; */
  text-align: left;
  line-height: 22px;
  font-size: 16px;
  color: #262626;
  /* height: 22px; */
  padding-bottom: 6px;
}
.export-info-category{
  /* margin-top: 6px; */
  /* padding-left: 30px; */
  /* width: 100%; */
  text-align: left;
  /* height: 22px; */
  line-height: 22px;
  font-size: 14px;
  color: #1D65A8;
  overflow: hidden;
  padding-bottom: 6px;
}
.export-info-category span {
  padding-right: 10px;
  /* margin-bottom: 6px; */
}
.export-info-introduction{
  width: 100%;
  height: 88px;
  text-align: left;
  line-height: 22px;
  font-size: 14px;
  color: #666666;
  letter-spacing: 0.4px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.export-info-label{
  position: absolute;
  bottom: 0;
  left: 20px;
  height: 20px;
  width: 100%;
  /* display: flex; */
}
.export-about-info{
  margin-right: 40px;
  display: inline-block;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  /* color: #1D65A8; */
  letter-spacing: 0;
  /* width: 10px; */
  cursor: pointer;
}
.export-about-info:hover{
  color: #1D65A8;
}
.export-about-info-count{
  color: #1D65A8;
  font-size: 16px;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 115px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
/* 分页区域样式结束 */
h3 {
  margin: 0;
}
</style>
